import { FormUserAdminLayout, MenuLayout } from "../layouts";

export const CreateUserPage = () => {
  return (
    <>
      <MenuLayout>
        <FormUserAdminLayout titlePage="Alta de Nuevo Usuario" />
      </MenuLayout>
    </>
  );
};
